export const dictionary = {
  LOGIN: {
    ES: "Iniciar sesión",
    EN: "Login",
  },
  LOGIN_TO: {
    ES: "Iniciar sesión en",
    EN: "Login to",
  },
  LOGIN_HOME: {
    ES: "Inicio de sesión",
    EN: "Login",
  },
  REGISTER: {
    ES: "Regístrate",
    EN: "Register",
  },
  EMAIL: {
    ES: "Email",
    EN: "Email address",
  },
  PASSWORD: {
    ES: "Contraseña",
    EN: "Password",
  },
  NEW_PASSWORD: {
    ES: "Nueva contraseña",
    EN: "New password",
  },
  FORGOT_PASSWORD: {
    ES: "¿Has olvidado tu contraseña?",
    EN: "Forgot password?",
  },
  RESET_PASSWORD: {
    ES: "Restablecer contraseña",
    EN: "Reset password",
  },
  NO_ACCOUNT: {
    ES: "¿No tienes cuenta?",
    EN: "No account?",
  },
  CREATE_ONE: {
    ES: "Create una",
    EN: "Create one",
  },
  CREATE_ACCOUNT: {
    ES: "Crear cuenta",
    EN: "Create account",
  },
  HAVE_ACCOUNT: {
    ES: "¿Ya tienes una cuenta?",
    EN: "Already have an account?",
  },
  CONTINUE_FACEBOOK: {
    ES: "Continuar con Facebook",
    EN: "Continue with Facebook",
  },
  CONTINUE_GOOGLE: {
    ES: "Continuar con Google",
    EN: "Continue with Google",
  },
  RETURN_TO: {
    ES: "Volver al",
    EN: "Return to",
  },
  CREATE_YOUR_NEW_PASS: {
    ES: "Crea tu nueva contraseña",
    EN: "Create your new password",
  },
  ENTER_NEW_PASS: {
    ES: "Ingresa tu nueva contraseña.",
    EN: "Enter your new password.",
  },
  SEND_EMAIL: {
    ES: "Enviar email",
    EN: "Send email",
  },
  SENT_EMAIL: {
    ES: "Email enviado",
    EN: "Sent email",
  },
  DESCRIPTION_RESET_EMAIL: {
    ES: "Ingresa tu email y te enviaremos un enlace para que restablezcas tu contraseña.",
    EN: "Enter your email address and we will send you a password reset link.",
  },
  PASS_RESETED: {
    ES: "¡Contraseña restablecida!",
    EN: "Password reseted!",
  },
} as const;
